export const NGSF_AB_TEST_TARGET_MBOX = 'target-nextGenSearch-mbox';
export const SEARCHFORM_EXPERIENCE_NGSF = 'ngsf';
export const SEARCHFORM_EXPERIENCE_BSF = 'bsf';
export const NGSF_ITEM_TYPE = 'mi-aem-shop-spa/components/content/ngsearchform/v1/ngsearchform';
export const BSF_ITEM_TYPE = 'mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform';
export const SEARCHFORM_ITEM_TYPE = 'mi-aem-shop-spa/components/content/searchform/v1/searchform';
